import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';

function RouterTest({extra, router, view}) {
  return (
    <div className={styles.routerTest}>
      <h1>{decodeURI(extra.params.text)}</h1>
      <input
        type="text"
        ref={(input) => this.textInput = input}
        placeholder="route param"
      />
      <button
        onClick={() => router.navigate(`/test/${this.textInput.value}`)}
      >Go</button>
    </div>
  );
}

export default inject('router', 'view')(observer(RouterTest));



// WEBPACK FOOTER //
// ./src/views/RouterTest/RouterTest.js